import Card from '../components/partials/Card';
import Footer from '../components/partials/Footer';

const Login = () => {
	return (
		<div className='w-full my-0 mx-auto' style={{ background: '#f9f9f9' }}>
			<div className='min-h-screen w-full flex flex-wrap items-center justify-center p-4'>
				<div className='w-full max-w-2xl'>
					<Card title='LOGIN' className='p-9' headerStyle='text-3xl'>
						<form>
							<div className='my-4'>
								<label
									htmlFor='email'
									className='font-semibold text-gray-600 text-lg'
								>
									Email
								</label>
								<input
									className='form-input'
									type='email'
									id='email'
									placeholder='Type your email ...'
								/>
							</div>
							<div className='my-4'>
								<label
									htmlFor='password'
									className='font-semibold text-gray-600 text-lg'
								>
									Password
								</label>
								<input
									className='form-input'
									type='password'
									id='password'
									placeholder='Type your password ...'
								/>
							</div>

							<button
								type='submit'
								className='button-dark py-2 w-full text-xl'
							>
								SUBMIT
							</button>
						</form>
					</Card>
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default Login;
